export default "__VITE_ASSET__DGaYLO08__"